import baseSelectBoxesForm from 'formiojs/components/selectboxes/SelectBoxes.form';

export default baseSelectBoxesForm;
